import "./style.css";
import BackButton from "../../../Composant/Back_Button/back_button";
import XPs_JSON from "./XPs.json";
import MediaRessources from "../../../ressources/media-ressources";

const techLogos = {
  // --- Frontend ---
  react:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
  angular:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg",
  figma:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg",

  // --- Backend ---
  java: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
  python:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
  javascript:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
  nodejs:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
  nestjs:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nestjs/nestjs-original.svg",
  spring:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg",
  laravel:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/laravel/laravel-original.svg",

  // --- Bases de données ---
  mysql:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
  postgresql:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg",
  mongodb:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
  redis:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg",

  // --- DevOps / Cloud ---
  docker:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
  kubernetes:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg",
  terraform:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/terraform/terraform-original.svg",
  ansible:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/ansible/ansible-original.svg",
  aws: "https://raw.githubusercontent.com/devicons/devicon/54cfe13ac10eaa1ef817a343ab0a9437eb3c2e08/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
  azure:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg",

  // --- CI/CD & Build ---
  gitlab:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/gitlab/gitlab-original.svg",
  jenkins:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-original.svg",
  maven:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/maven/maven-original.svg",
  gradle:
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/gradle/gradle-original.svg",

  // --- Outils collaboratifs ---
  notion:
    "https://upload.wikimedia.org/wikipedia/commons/4/45/Notion_app_logo.png",
  miro: "https://seeklogo.com/images/M/miro-logo-870C9AD037-seeklogo.com.png",
};

const ExperienceCard = ({ exp, index }) => {
  const positionClass = index % 2 === 0 ? "left" : "right";

  return (
    <div className={`experience-card ${positionClass}`}>
      <div className="experience-content">
        <div className={`experience-header ${positionClass}`}>
          <h2 className="experience-company">{exp.company}</h2>
          <img
            src={MediaRessources.listLogoExperiences[exp.logo]}
            className="experience-logo"
            alt={`${exp.alt_company}`}
          />
        </div>

        <h3>{exp.title}</h3>
        <span className="experience-dates">{exp.date}</span>

        <p
          className="experience-description"
          dangerouslySetInnerHTML={{ __html: exp.description }}
        ></p>

        {exp.team && (
          <p className="experience-methodology">
            <strong>Composition de l'équipe :</strong> <br /> {exp.team}
          </p>
        )}

        {exp.methodology && (
          <p className="experience-methodology">
            <strong>Méthodologie :</strong> {exp.methodology}
          </p>
        )}

        {exp.techs?.length > 0 && (
          <div className="tech-stack">
            {exp.techs.map((tech, idx) => (
              <img
                key={idx}
                src={techLogos[tech]}
                alt={tech}
                className="tech-icon"
              />
            ))}
          </div>
        )}

        {exp.link && (
          <a
            href={exp.link}
            className="experience-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            🌐 Voir le site
          </a>
        )}
      </div>
    </div>
  );
};

const ExperiencePage = () => {
  return (
    <div className="experience-page">
      <BackButton link="/#section_about" />

      <p className="title-experience">💼 Mon Parcours Professionnel</p>
      <div className="timeline">
        {XPs_JSON.map((exp, index) => (
          <ExperienceCard key={index} exp={exp} index={index} />
        ))}
      </div>
    </div>
  );
};

export default ExperiencePage;
